import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@rio-cloud/rio-uikit/Button';

import { connect } from 'react-redux';
import { InfoDialogMenu } from './InfoDialogMenu';
import { InfoPages } from './InfoPages';
import { Chapter } from './Chapter';
import { selectInfoModalChapter } from '../../../routes/selector';
import { closeInfoModal, setActiveInfoModalChapter } from '../../../routes/actions';
import SplitDialog from '@rio-cloud/rio-uikit/SplitDialog';
import { type RouteComponentProps, withRouter } from '../../../routes/routerUtils';

const INFO_DIALOG_TITLE_ID = 'intl-msg:infoDialog.title';

interface StateProps {
    // biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience for migration to biomejs
    setActiveChapter: (chapter: any) => void;
    chapter: Chapter | null;
}

interface DispatchProps {
    closeInfoModal: () => void;
}

export const InfoModalUnconnected = (props: StateProps & DispatchProps) => {
    const { chapter, setActiveChapter, closeInfoModal } = props;

    // biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience for migration to biomejs
    const handleSelectChapter = (event: any) => {
        event.preventDefault();
        setActiveChapter(event.target.getAttribute('data-name'));
    };

    return (
        <SplitDialog
            show={Boolean(chapter)}
            title={
                <div className='display-flex align-items-center justify-content-between'>
                    <FormattedMessage id={INFO_DIALOG_TITLE_ID} />
                    <Button
                        bsStyle={Button.MUTED}
                        iconOnly
                        iconName='remove'
                        autoTrackingKey={`${INFO_DIALOG_TITLE_ID.replace('intl-msg:', '')}.close`}
                        onClick={() => closeInfoModal()}
                        aria-label='Close dialog'
                    />
                </div>
            }
            leftContent={<InfoDialogMenu chapter={chapter ?? Chapter.WELCOME} onSelectChapter={handleSelectChapter} />}
            rightContent={chapter ? <InfoPages chapter={chapter} /> : <React.Fragment />}
            onClose={() => closeInfoModal()}
            showCloseButton={false}
            bsSize={'lg'}
        />
    );
};

// biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience for migration to biomejs
const mapStateToProps = (_state: any, ownProps: RouteComponentProps): StateProps => ({
    chapter: selectInfoModalChapter(ownProps),
    setActiveChapter: (chapter: string) => setActiveInfoModalChapter(chapter, ownProps),
});

// biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience for migration to biomejs
const mapDispatchToProps = (_dispatch: any, ownProps: RouteComponentProps): DispatchProps => ({
    closeInfoModal: () => {
        closeInfoModal(ownProps);
    },
});

export const InfoModal = withRouter(connect(mapStateToProps, mapDispatchToProps)(InfoModalUnconnected));
